import { Box} from "@mui/material"
import ActionCard from "../../../../../actionPlans/pages/form/components/actionCard"
import { BodySectionActionBodyProps } from "./types"
import { useStyles } from "./styles"

const BodySectionActionBody = ({ title, userType, curp, role }: BodySectionActionBodyProps) => {
    const styles = useStyles()
    
    return (
        <Box sx={[styles.flex, styles.containerInformation]}>
            <ActionCard.Title variant="subtitle" fontWeight='bold' label={title} />

            <ActionCard.Description variant="subtitle" fontWeight='bold' label={userType} />

            <ActionCard.Description variant="subtitle" fontWeight='bold' label={curp} />

            {role && <ActionCard.SubTitle variant="subtitle_blue" label={role} />}
        </Box>
    )
}

export { BodySectionActionBody }
